import { convertToString } from 'helpers/errors';

export const ERROR_MESSAGE = 'Sorry, an unexpected error occurred. Please refresh and try again.';

const ErrorMessage = ({ message = ERROR_MESSAGE }) => (
  <div className="centeredContainer mb-6 bg-red-50 p-3 text-center font-semibold text-red-100">
    <p role="alert">{convertToString(message)}</p>
  </div>
);

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;
